import { ConfigApi as ConfigApiInternal, InvestorPortalConfig } from '@portal/pkg-api/gen/shared'
import { useEffectiveUser } from '@shared/data/UserInfo'
import { useQuery } from '@tanstack/react-query'
import { RestApiConfiguration } from '@portal/pkg-api/config'
import { UserBasic } from '@portal/pkg-api/gen/auth'
import { data } from '@portal/pkg-api/shared'

export const ConfigApi = new ConfigApiInternal(RestApiConfiguration)

const prefix = 'shared.config'

export const ConfigQueries = {
  configBase: (effectiveUser: UserBasic) => ({
    queryKey: [`${prefix}.configBase`, effectiveUser.id],
    queryFn: () => data(ConfigApi.getConfigBase({ mercatusNotifyOnError: false })),
  }),
}

export function useConfigBase() {
  const effectiveUser = useEffectiveUser()
  return useQuery<InvestorPortalConfig>({
    ...ConfigQueries.configBase(effectiveUser!),
    enabled: !!effectiveUser,
  })
}
